import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { MeasureableValuesService } from 'src/app/services/measureableValues/measureable-values.service';
import { ActivatedRoute, Params } from '@angular/router';
import { MeasureableUnitsService } from 'src/app/services/measureableUnits/measureable-units.service';
import {Location} from '@angular/common';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { OpenNativeSettings } from '@ionic-native/open-native-settings/ngx';
import { AlertComponent } from 'src/app/shared/alert/alert.component';
import { AreaService } from '../../services/Area/area.service';
import { google } from 'google-maps';


@Component({
  selector: 'app-choose-functionality',
  templateUrl: './choose-functionality.page.html',
  styleUrls: ['./choose-functionality.page.scss'],
})
export class ChooseFunctionalityPage implements OnInit {
  favoriteSeason: string;
  measurableId:any;
  measureableUnitData:any;
  allUnits:any;
  viewFlag:boolean = false;
  areaId:any;
  geoCoder: any;
  place: any;
 
  constructor(
    private areaServic:AreaService,
    private navCtrl:NavController,
    private measureableValuesService:MeasureableValuesService,
    private activatedroute:ActivatedRoute,
     private locationAccuracy: LocationAccuracy,
    private openNativeSettings: OpenNativeSettings,
    private measureableUnitsService:MeasureableUnitsService,
    private alert:AlertComponent,
    private areaService:AreaService,
    private _location: Location

    ) {
   
      this.measurableId = JSON.parse(localStorage.getItem('JobData')).measureableUnit;
      console.log(this.measurableId);
        this.measureableUnitsService.getMeasureableUnitsDetails(this.measurableId[0]).then((res)=>{
          console.log(res);
          this.measureableUnitData = res;
        this.measureableValuesService.getAllMeasureableValuess(this.measurableId[0]).then((ress)=>{
          console.log(ress);
          this.allUnits = ress;  
          this.viewFlag = true;
          if(JSON.parse(localStorage.getItem('JobData')).measureId){
            this.favoriteSeason = JSON.parse(localStorage.getItem('JobData')).measureId;
          }
        })
     
    })
    this.getallAreas();
   }
   
   getallAreas(){
    let place = localStorage.getItem('location');
    if(place){
      this.areaService.getAllAreas(place).then((res)=>{
        console.log(res);
        this.areaId = res[0].id;
      })
    }
   }


  goback(){
    this.navCtrl.pop();
	  }

  nextPage(){
    console.log(this.favoriteSeason);
    let data = JSON.parse(localStorage.getItem('JobData'));

    console.log(data);
    if(!data.city){
      data.city = this.place;
    }
    data.measureId = this.favoriteSeason;
    data.areaId = this.areaId;
    localStorage.setItem('JobData',JSON.stringify(data));
    this.navCtrl.navigateForward('/service-detail');
  }  

  ngOnInit() {
    this.locationaccuracy();
  }

  locationaccuracy(){
    this.locationAccuracy.canRequest().then((canRequest: boolean) => {
      console.log("can request",canRequest);
      if(canRequest) {
        // the accuracy option will be ignored by iOS
        this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
          () => {
            console.log('Request successful');
              this.getAddress();
          },
          error => {
            this.alert.presentAlertConfirm("Some of the features of the app require your location to function optimally.","cancel","settings").then((res)=>{
              if(res['role'] == 'cancel' ){
                console.log("cancel");
              }else{
                this.openNativeSettings.open("locations").then((res)=>{
                  console.log("res",res);
                  
                  setTimeout(() => {
                      this.getAddress();
                    }, 7000);
      
                }).catch((err)=>{
                  console.log("err",err);
                })
              }
              });
            console.log('Error requesting location permissions', error);
        }
        );
      }else{
        this.getAddress();
  
      }
    });
  }
  
  
    getAddress() {
      if ('geolocation' in navigator) {
        console.log("in navigator");
        this.geoCoder = new google.maps.Geocoder;
        navigator.geolocation.getCurrentPosition((position) => {
          console.log("in navigator Position",position);
          this.geoCoder.geocode({ 'location': { lat: position.coords.latitude, lng: position.coords.longitude } }, (results, status) => {
            console.log("in geocode Position",results,status);
            if (status === 'OK') {
          if (results[0]) {
            
            let plac = results[0].formatted_address.split(',');
            console.log(plac[plac.length - 3]);
            if(this.place){
              if(plac[plac.length - 3].toString().trim() !== this.place.toString().trim()){
                localStorage.setItem('location',plac[plac.length - 3]);
                this.getallAreas();
              }
            }else{
              this.place = plac[plac.length - 3];
              localStorage.setItem('location',plac[plac.length - 3]);
              this.getallAreas();
            }
          } else {
            window.alert('No results found');
          }
          } else {
          window.alert('Geocoder failed due to: ' + status);
          }
        });
      });
    }
    }
    ionViewDidEnter() {
      this.areaServic.showHome=false
    }
  }
